export default __webpack_public_path__ + "386f9114fcfd1b4b2963c63826fff1e2.png";